/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".widget-settings[_ngcontent-%COMP%]{position:absolute;right:100%;top:0;padding:5px;border:1px solid gray;border-top:2px solid gray;background-color:#fff}#collapse-btn[_ngcontent-%COMP%]{padding:0;text-align:left;height:24px;width:24px;top:-6px}"];
export { styles as styles };
